__webpack_require__.p = "/lets-play-chess/";